/* global addJobViewURL, internalSource, externalSource -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import '@common/bootstrap';

import '@common/mobile.menu';
import '../../plugins/dl-menu/js/jquery.dlmenu';

import { addJobView } from '@common/analytics';
import NavBar from '@components/nav-bar';

$(() => {
    NavBar.init($);

    addJobView(addJobViewURL, internalSource, externalSource);
    $("[data-toggle='tooltip']").tooltip();
});
